import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
import App from './App.vue'
import router from './router'
import store from './store'
import * as filters from '@/utils/filter'
import Directives from './directive'
import 'normalize.css/normalize.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/icons'
import '@/permission'
import '@/components/BackToTop'
import '@/styles/index.scss'
import 'nprogress/nprogress.css'

// import { Message } from 'element-ui'
// import { TokenKey, setToken, setUserInfo } from '@/utils/auth' // 验权
// import { getCurrentUserInfo } from '@/api/login'
// import { getQueryObject } from '@/utils/index'
// import { routeInfo } from '@/store/modules/route-info'

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
console.log('%c 当前环境: ', 'font-size:14px;background-color: #7F2B82;color:#fff;', process.env.VUE_APP_NODE_ENV)

Object.keys(filters).forEach(k => Vue.filter(k, filters[k])) // 注册过滤器
Vue.use(Directives) // 注册指令

Vue.config.productionTip = false // 设置为 false 以阻止 vue 在启动时生成生产提示

Vue.use(VueCompositionAPI)
Vue.use(ElementUI)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
